import React, { createContext, ReactNode, useContext } from 'react'

// Invalid state for the compound field primitives. A field wrapper (label +
// control + hint + error row) owns the error, but the red border is painted by
// the control — which may sit anywhere inside the wrapper's subtree, next to a
// hint or inside another component. Cloning the child to inject `isInvalid`
// only reaches a single direct child; the context reaches every control the
// wrapper renders. An explicit `isInvalid` prop always wins over the context.

const FieldInvalidContext = createContext(false)

export const FieldInvalidProvider: React.FC<{
    isInvalid?: boolean
    children: ReactNode
}> = ({ isInvalid = false, children }) => (
    <FieldInvalidContext.Provider value={isInvalid}>{children}</FieldInvalidContext.Provider>
)

export const useFieldInvalid = () => useContext(FieldInvalidContext)
